/**
 * <s-nav-accordion> — mobile menu item whose title is a real link and whose
 * separate arrow button expands or collapses its submenu in place.
 *
 * Required child markup:
 *   button[data-accordion-toggle] — toggle; `aria-controls` holds the submenu id.
 *   [id]                          — the submenu, rendered with the `hidden` attribute.
 */
class SNavAccordion extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const button = this.querySelector('[data-accordion-toggle]');
    if (!(button instanceof HTMLElement)) return;
    const panelId = button.getAttribute('aria-controls');
    const panel = panelId ? this.querySelector(`[id="${panelId}"]`) : null;
    if (!(panel instanceof HTMLElement)) return;

    button.addEventListener(
      'click',
      () => {
        const open = button.getAttribute('aria-expanded') !== 'true';
        button.setAttribute('aria-expanded', open ? 'true' : 'false');
        panel.hidden = !open;
      },
      { signal: this.#ac.signal }
    );
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

customElements.define('s-nav-accordion', SNavAccordion);
